import React, { Component } from "react";
import { connect } from "react-redux";
import ReactDOM from "react-dom";
import KpsListItem from "../../core-elements/KpsListItem";
import ListItemText from "@material-ui/core/ListItemText";
import { withRouter } from "react-router";
import { withTranslation } from "react-i18next";
import ListItems from "../list/ListItems";
import AddIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import axios from "../../AxiosClient";
import PubSub from "pubsub-js";
import AreYouSureDialog from "../dialog/AreYouSureDialog";
import { PORTLET_LAYOUT_ADD, USER_LIST_DELETE } from "../../utils/Topics";

export class ListItem extends Component {
  state = {
    extendedString: "",
    documentViewerOpen: false,
    viewingDocument: null,
    instance: new Date().getTime().toString(),
    areYouSureDialog: false,
  };

  render() {
    const child = (
      <div>
        <KpsListItem
          preText={this.props.preText}
          isPortlet={this.props.isPortlet}
          onItemClick={this.onItemClick}
          extendedString={<ListItems data={this.props.data} />}
          provided={this.props.provided}
        >
          {this.props.preText}
          <ListItemText
            style={{ overflowWrap: "anywhere" }}
            primary={this.props.data.title}
            secondary={this.getSecondaryInfo()}
          />
          <Tooltip title={this.props.t("delete_list")}>
            <IconButton
              style={{ padding: 8, marginTop: -9 }}
              onClick={this.openDialog}
            >
              <DeleteIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title={this.props.t("add_list_to_layout")}>
            <IconButton
              style={{ padding: 8, marginTop: -9 }}
              onClick={this.addListToLayout}
            >
              <AddIcon />
            </IconButton>
          </Tooltip>
        </KpsListItem>
        <AreYouSureDialog
          open={this.state.areYouSureDialog}
          onClose={this.openDialog}
          onSubmit={this.deleteList}
        />
      </div>
    );
    if (this.props.snapshot && this.props.snapshot.isDragging) {
      return ReactDOM.createPortal(child, document.body);
    }
    return child;
  }

  getSecondaryInfo() {
    let settings = this.props.listSettings;
    if (!settings) {
      settings = "settings_listuserlist_items";
    }
    let listItems = 0
    if (this.props.data && this.props.data.items) {
      try {
        listItems = JSON.parse(this.props.data.items).length
      } catch (x) {
        listItems = 0
      }
    } 
    const { classes } = this.props;
    let info = (
      <div>
        {settings === "settings_listuserlist_created_date" &&
          this.props.t("settings_listuserlist_created_date") +
            " " +
            this.props.data.dateCreated}
        {settings === "settings_listuserlist_modified_date" &&
          this.props.t("settings_listuserlist_modified_date") +
            " " +
            this.props.data.dateModified}
        {settings === "settings_listuserlist_items" &&
          this.props.t("settings_listuserlist_items") +
            " " +
            listItems}
      </div>
    );

    return info;
  }

  addListToLayout = (e) => {
    e.stopPropagation();
    let portlet = {
      elementType: "CardList",
      parameters: JSON.stringify({ listID: this.props.data.id }),
      parametersString: JSON.stringify({ listID: this.props.data.id }),
      objectClass: "com.kpsol.api.apicommon.list.UserListInterface",
      title: this.props.data.title,
      isportlet: true,
      fullscreen: false,
      id: null,
      icon: "assignment",
      instance: new Date().getTime(),
    };

    axios
      .post(`/portalLayout/${this.props.portalLayout.id}/portlet/`, {
        ...portlet,
      })
      .then((res) => {
        PubSub.publish(PORTLET_LAYOUT_ADD, {
          layoutId: this.props.portalLayout.id,
          portletId: res.data.id,
        });
      });
  };

  openDialog = () => {
    this.setState({
      areYouSureDialog: this.state.areYouSureDialog ? false : true,
    });
  };

  deleteList = () => {
    axios.delete(`/userlist/${this.props.data.id}/`).then((res) => {
      PubSub.publish(USER_LIST_DELETE, {});
      this.openDialog();
    });
  };
}

const mapStateToProps = (state) => ({
  settings: state.setting.documentSettings,
  portalLayout: state.layout.currentLayout,
});

export default connect(
  mapStateToProps,
  null,
  null,
  { forwardRef: true }
)(withRouter(withTranslation()(ListItem)));
